<template>
  <div>
   <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <div class="top-spacer"></div>
      <!-- <AppHeader /> -->
      <div class="body flex-grow-1 px-5">
        <TheReminder/>
        <router-view :key="$route.path" />
      </div>
      <GlobalSearch />
      <AppFooter />
    </div>
  </div>
</template>
<script>
//import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
//import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import TheReminder from '@/components/TheReminder.vue'
import GlobalSearch from '@/components/GlobalSearch.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
  //  AppHeader,
    AppSidebar,
   // CContainer,
    TheReminder,
    GlobalSearch,
  },
}
</script>

<style scoped>
.top-spacer {
  height: 16px;
}
</style>
